import { Link } from "react-router-dom";
const WelcomeModal = () => {
  return (
    <div className={`relative flex flex-col justify-start items-center top-[210px] left-[420px] w-[233.5px] h-[235px] text-darkslategray`}>
      <div className={`rounded-mini bg-white shadow-[-10.383894920349121px_-8.495914459228516px_28.32px_rgba(0,_0,_0,_0.35),_12.271876335144043px_11.327885627746582px_28.32px_rgba(0,_0,_0,_0.35)] backdrop-blur-lg absolute inset-0 w-[233.5px] h-[235px]`} />
      <img
        className="absolute h-[34.14%] w-[55.43%] top-[-15%] right-[24.83%] bottom-[65.86%] left-[19.75%] max-w-full overflow-hidden max-h-full"
        alt=""
        src="/illustration.svg"
      />
      <div className="z-0 mt-[55px] font-semibold w-[135.03px] h-[24.05px]">
        Welcome
      </div>
      <div className="absolute text-[10px] w-[83.6%] top-[35%] left-[7.66%] inline-block">
        <p className="[margin-block-start:0] [margin-block-end:9.16px]">{`Welcome to the interactive guide on using the OneScreen L7 Touchscreen. `}</p>
        <p className="m-0">
          This initial guide will walk you through the different features and
          elements that are present on your home screen.
        </p>
      </div>
      <img
        className="z-0 mt-[105px] w-[245.5px] h-0.25"
        alt=""
        src="/vector-9.svg"
      />
      <div className="absolute h-[8.39%] w-[67.01%] top-[85.85%] right-[16.4%] bottom-[5.76%] left-[16.59%]">
        <Link to="/home" className="decoration-transparent">
          <div className="absolute h-full w-[47.85%] top-[0%] right-[52.15%] bottom-[0%] left-[0%]">
            <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-mini bg-lightsteelblue" />
            <div className="absolute text-darkslategray text-[9px] w-full top-[23.33%] left-[0%] inline-block">
              Skip
            </div>
          </div>
        </Link>
        <Link to="/useraccounts" className="decoration-transparent">
          <div className="absolute h-full w-[47.85%] top-[0%] right-[0%] bottom-[0%] left-[52.15%] text-white">
            <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-[25px] bg-yellowgreen" />
            <div className="absolute text-[9px] w-full top-[20%] left-[0%] inline-block hover: cursor-pointer">
              Continue
            </div>
          </div>
        </Link>
      </div>
      <Link to="/home" className="decoration-transparent">
        <img
          className="absolute h-[13px] w-[13px] top-[4%] right-[4%] max-w-full overflow-hidden max-h-full"
          alt=""
          src="/close.svg"
        />
      </Link>
    </div>
  );
};

export default WelcomeModal;
